import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { getCampaignCreationRequests, getCampaignModificationRequestDetails, getCampaignModificationRequests, getCampaignRequestDetails, getSupportTicketById, getSupportTickets, markTicketAsResolved, resolveCampaignCreationRequest, resolveCampaignModificationRequest } from "../api/partner";

export const useGetSupportTickets = () => {
    return useQuery({
        queryKey: ['support-tickets'],
        queryFn: getSupportTickets,
    });
}

export const useGetSupportTicketsById = (ticketId) => {
    return useQuery({
        queryKey: ['support-ticket', ticketId],
        queryFn: () => getSupportTicketById(ticketId),
    });
}

export const useMarkTicketAsResolved = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationKey: ['mark-ticket-resolved'],
        mutationFn: (data) => markTicketAsResolved(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['support-tickets']);
        },
    });
}

export const useGetCampaignCreationRequests = () => {
    return useQuery({
        queryKey: ['campaign-creation-requests'],
        queryFn: () => getCampaignCreationRequests(),
    });
}

export const useGetCampaignCreationRequestsById = (requestId) => {
    return useQuery({
        queryKey: ['campaign-creation-request', requestId],
        queryFn: () => getCampaignRequestDetails(requestId),
    });
}

export const useResolveCampaignCreationRequest = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationKey: ['resolve-campaign-creation-request'],
        mutationFn: (data) => resolveCampaignCreationRequest(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['campaign-creation-requests']);
        },
    });
}

export const useGetCampaignModificationRequest = () => {
    return useQuery({
        queryKey: ['campaign-modification-requests'],
        queryFn: () => getCampaignModificationRequests(),
    });
}

export const useGetCampaignModificationRequestById = (requestId) => {
    return useQuery({
        queryKey: ['campaign-modification-request', requestId],
        queryFn: () => getCampaignModificationRequestDetails(requestId),
    });
}

export const useResolveCampaignModificationRequest = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationKey: ['resolve-campaign-modification-request'],
        mutationFn: (data) => resolveCampaignModificationRequest(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['campaign-modification-requests']);
        },
    });
}